import React from 'react';
import { TeamCompositionItem } from './components/components';
import { TeamCompositionItem as TTeamCompositionItem } from '~/common/types/types';
import * as styles from './team-composition-list.module.scss';

type Props = {
  items: TTeamCompositionItem[];
};

const TeamCompositionList: React.FC<Props> = ({ items }) => {
  return (
    <ul className={styles.wrapper}>
      {items.map((it) => (
        <TeamCompositionItem
          key={it.title}
          item={it}
          className={styles[it.role]}
        />
      ))}
    </ul>
  );
};

export { TeamCompositionList };
